import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { push } from 'connected-react-router';
import { EUserGroup, IProject, IUser } from '@relab/alstom-ptw-shared';

import { PtwsListComponent } from './PtwsListComponent';
import { appState } from '../../redux/selectors';
import { RootState } from '../../redux/types';

interface PPtwsComponentProps {
  projectId: string;
  user: IUser;
  project: IProject;
  push: typeof push;
}

const PPtwsComponent: React.FC<PPtwsComponentProps> = ({ projectId, user, project, push }) => {
  const canCreate = !project.assignees
    .filter((a) => a.user._id === user._id)
    .some((a) => a.group === EUserGroup.PRTCM_READONLY);

  return (
    <React.Fragment>
      {canCreate && <Button onClick={() => push(`/projects/${projectId}/create`)}>Create</Button>}
      <PtwsListComponent projectId={projectId} />
    </React.Fragment>
  );
};

const mapStateToProps = (state: RootState) => ({
  user: appState(state).user,
  project: appState(state).project,
});

export const PtwsComponent = connect(mapStateToProps, { push })(PPtwsComponent);
